import { TextField, TextFieldProps } from '@mui/material'

export type InputProps = TextFieldProps

export function Input(props: TextFieldProps) {
  return <TextField {...props} />
}
